var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgEmptyActivityLog = function SvgEmptyActivityLog(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 336,
    height: 372,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "50%",
    x2: "100%",
    y2: "50%",
    id: "EmptyActivityLog_svg__a"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8ECF7",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "50%",
    x2: "100%",
    y2: "50%",
    id: "EmptyActivityLog_svg__b"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8ECF7",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "50%",
    x2: "100%",
    y2: "50%",
    id: "EmptyActivityLog_svg__c"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE0F5",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8ECF9",
    offset: "45.3%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "100%",
    y1: "50%",
    x2: "0%",
    y2: "50%",
    id: "EmptyActivityLog_svg__d"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1D7F3",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "37.347%",
    x2: "22.819%",
    y2: "64.85%",
    id: "EmptyActivityLog_svg__e"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#56B1B0",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B7978",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "99.999%",
    y1: "50.001%",
    x2: "0%",
    y2: "50.001%",
    id: "EmptyActivityLog_svg__f"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1D7F3",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "37.346%",
    x2: "22.819%",
    y2: "64.851%",
    id: "EmptyActivityLog_svg__g"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#56B1B0",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B7978",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "100%",
    y1: "50%",
    x2: "0%",
    y2: "50%",
    id: "EmptyActivityLog_svg__h"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1D7F3",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "49.999%",
    x2: "100%",
    y2: "49.999%",
    id: "EmptyActivityLog_svg__i"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CED3F8",
    offset: "39.6%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BEC3E9",
    offset: "55.2%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBC0E6",
    offset: "57.4%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "100%",
    y1: "50.002%",
    x2: "0%",
    y2: "50.002%",
    id: "EmptyActivityLog_svg__j"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1D7F3",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "50%",
    x2: "100%",
    y2: "50%",
    id: "EmptyActivityLog_svg__k"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CED3F8",
    offset: "39.6%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BEC3E9",
    offset: "55.2%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBC0E6",
    offset: "57.4%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "50%",
    x2: "100%",
    y2: "50%",
    id: "EmptyActivityLog_svg__l"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4CAE8",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CED3EC",
    offset: "9.5%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9EBF6",
    offset: "40.9%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9FAFD",
    offset: "68.7%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    offset: "89.9%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "50%",
    x2: "100%",
    y2: "50%",
    id: "EmptyActivityLog_svg__m"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4CAE8",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CED3EC",
    offset: "9.5%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9EBF6",
    offset: "40.9%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9FAFD",
    offset: "68.7%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    offset: "89.9%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "99.999%",
    y1: "49.998%",
    x2: "0%",
    y2: "49.998%",
    id: "EmptyActivityLog_svg__n"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#423EAF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A35A0",
    offset: "30.4%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#241E77",
    offset: "89.1%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F196F",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50.429%",
    y1: "59.781%",
    x2: "55.352%",
    y2: "37.492%",
    id: "EmptyActivityLog_svg__o"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F63",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DE5020",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-2098.305%",
    y1: "50.001%",
    x2: "-1998.307%",
    y2: "50.001%",
    id: "EmptyActivityLog_svg__p"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#423EAF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A35A0",
    offset: "30.4%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#241E77",
    offset: "89.1%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F196F",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50.732%",
    y1: "59.781%",
    x2: "50%",
    y2: "28.772%",
    id: "EmptyActivityLog_svg__q"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F63",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DE5020",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "100%",
    y1: "50%",
    x2: "0%",
    y2: "50%",
    id: "EmptyActivityLog_svg__r"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBC0E6",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E7F5",
    offset: "66.2%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6F6FB",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "52.97%",
    y1: "63.537%",
    x2: "-51.245%",
    y2: "162.197%",
    id: "EmptyActivityLog_svg__s"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBC0E6",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E7F5",
    offset: "48.816%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6F6FB",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "100%",
    y1: "50%",
    x2: "0%",
    y2: "50%",
    id: "EmptyActivityLog_svg__t"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBC0E6",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E7F5",
    offset: "66.2%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6F6FB",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "50.001%",
    x2: "100%",
    y2: "50.001%",
    id: "EmptyActivityLog_svg__u"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#383564",
    offset: "50.9%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#252240",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "168.308%",
    y1: "24.309%",
    x2: "-53.256%",
    y2: "70.227%",
    id: "EmptyActivityLog_svg__v"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBC0E6",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E7F5",
    offset: "66.2%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6F6FB",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "50%",
    x2: "100%",
    y2: "50%",
    id: "EmptyActivityLog_svg__w"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1D7F3",
    offset: "42.7%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D7DCF5",
    offset: "48.6%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4F6FC",
    offset: "81.3%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-.001%",
    y1: "50.001%",
    x2: "100%",
    y2: "50.001%",
    id: "EmptyActivityLog_svg__x"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAF6D",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F39356",
    offset: "35.9%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E97A41",
    offset: "75.8%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E57139",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-709.615%",
    y1: "50.001%",
    x2: "-609.614%",
    y2: "50.001%",
    id: "EmptyActivityLog_svg__y"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1D7F3",
    offset: "42.7%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D7DCF5",
    offset: "48.6%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4F6FC",
    offset: "81.3%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-752.191%",
    y1: "50%",
    x2: "-652.19%",
    y2: "50%",
    id: "EmptyActivityLog_svg__z"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAF6D",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F39356",
    offset: "35.9%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E97A41",
    offset: "75.8%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E57139",
    offset: "100%"
  })))), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m213.053 201.681 3.344 1.931-85.749 49.507c-12.75-6.609-32.375-6.375-44.637.704-12.682 7.322-12.682 19.194 0 26.516 12.682 7.322 33.244 7.322 45.927 0 12.261-7.08 12.666-18.41 1.218-25.771l85.75-49.507 3.343 1.93 9.275-10.664-18.471 5.354Z",
    fill: "#E8ECF7",
    fillRule: "nonzero"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FB944B",
    fillRule: "nonzero",
    d: "m231.524 31.453 5.969-3.445L216.07 15.64l-5.968 3.446zM254.65 44.805l5.969-3.446-21.422-12.367-5.968 3.445zM266.213 51.481l5.969-3.446-9.86-5.692-5.968 3.446 9.859 5.692z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m219.088 37.522-8.884-5.13v-1.967l10.61 6.101-1.726.996Zm4.343 15.755-13.328-7.695 1.725-.996 8.133 4.72 1.705-.984v1.968l3.47 2.003-1.705.984Zm-3.47 11.245-9.757-5.633V56.92l11.462 6.617-1.705.984Zm7.813 4.51-6.108-3.526 1.704-.984 6.108 3.527-1.704.984Zm3.75 15.416-21.32-12.309v-.117l1.603-.926 8.154 4.706 1.705-.984v1.968l11.563 6.678-1.705.984Zm-11.563 6.573-9.757-5.634V83.42l11.462 6.618-1.705.984Zm11.563 19.923-21.32-12.309v-.117l1.603-.925 8.154 4.708 1.705-.984v1.968l11.563 6.675-1.705.984Zm0 52.987-21.32-12.31v-.117l1.603-.925 8.154 4.708 1.705-.984v1.968l11.563 6.676-1.705.984Zm0-26.497-21.32-12.309v-.117l1.603-.925 8.154 4.707 1.705-.983v1.967l11.563 6.676-1.705.984Zm9.28-21.132-7.575-4.374 1.704-.984 7.575 4.374-1.704.984Z",
    fill: "#E8ECF7",
    fillRule: "nonzero",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#EmptyActivityLog_svg__a)",
    fillRule: "nonzero",
    style: {
      mixBlendMode: "multiply"
    },
    d: "m253.83 163.56-9.038-5.218 1.704-.984 9.038 5.218z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m219.961 117.517-9.757-5.634v-1.968l11.462 6.618-1.705.984Zm0 26.49-9.757-5.634v-1.968l11.462 6.618-1.705.984Zm0 26.496-9.757-5.634v-1.968l11.462 6.618-1.705.984Zm25.185-38.446-.354-.205 1.704-.984.354.205-1.704.984Zm-2.059-1.189-21.421-12.367 1.704-.984 8.154 4.708 1.705-.984v1.968l11.563 6.676-1.705.983Zm6.4 16.937-16.258-9.387 1.704-.984 8.154 4.708 1.705-.983v1.967l6.399 3.695-1.704.984Zm-6.4 9.553-21.421-12.367 1.704-.984 8.154 4.708 1.705-.984v1.968l11.563 6.675-1.705.984Zm11.563 19.924-21.421-12.367 1.704-.984 8.154 4.708 1.705-.984v1.967l11.562 6.676-1.704.984Zm-11.563 6.572-21.421-12.367 1.704-.984 8.154 4.708 1.705-.984v1.968l11.563 6.676-1.705.983Z",
    fill: "#E8ECF7",
    fillRule: "nonzero",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#EmptyActivityLog_svg__b)",
    fillRule: "nonzero",
    style: {
      mixBlendMode: "multiply"
    },
    d: "m262.515 195.071-17.723-10.233 1.704-.984 8.154 4.709 1.704-.984v1.968l7.865 4.54-1.704.984z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E8ECF7",
    fillRule: "nonzero",
    style: {
      mixBlendMode: "multiply"
    },
    d: "m236.46 100.546-14.794-8.541 1.704-.984 8.154 4.708 1.705-.984v1.967l4.936 2.85-1.704.984z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DAE0F5",
    fillRule: "nonzero",
    style: {
      mixBlendMode: "multiply"
    },
    d: "M285.299 219.506V56.91l-4.693-8.132v168.018l4.693 2.709z"
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#BBC0E6",
    fillRule: "nonzero",
    d: "M200.817 18.972V176.15l4.694-2.71V21.683z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#E3E8FF",
    fillRule: "nonzero",
    d: "M275.912 51.49v168.016l-9.383-5.417V56.912l-65.712-37.94V176.15l-9.383-5.417V2.716l84.478 48.773z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M275.912 51.49 191.424 2.71 196.118 0l84.488 48.78-4.694 2.71z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#BBC0E6",
    fillRule: "nonzero",
    d: "M275.912 51.49v168.016l4.694-2.71V48.78z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#DAE0F5",
    fillRule: "nonzero",
    style: {
      mixBlendMode: "multiply"
    },
    d: "M285.298 219.506h-9.386l4.694-2.71z"
  }), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#CED3F8",
    fillRule: "nonzero",
    d: "m144.491 56.911 61.02-35.229 4.693 2.71V176.15l-65.713 37.939z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#BBC0E6",
    fillRule: "nonzero",
    d: "m153.637 138.637-6.243 3.605v7.208l6.243-3.604z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#E8ECF7",
    fillRule: "nonzero",
    d: "m154.748 144.266-3.326-1.92-1.813 1.046 5.139 2.967 8.457-4.883-1.81-1.046-6.647 3.836z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#BBC0E6",
    fillRule: "nonzero",
    d: "M163.205 143.569v-2.093l-8.457 4.883v2.094l8.457-4.884z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M154.748 148.452v-2.093l-5.139-2.967v2.094l5.139 2.966Zm-10.257-91.54v157.177l-4.694-2.71V54.202l4.694 2.71Z",
    fill: "#D9DFFF",
    fillRule: "nonzero"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#F6F6FB",
    fillRule: "nonzero",
    d: "m205.51 21.682-61.019 35.23-4.694-2.71 61.02-35.23z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#EmptyActivityLog_svg__c)",
    fillRule: "nonzero",
    style: {
      mixBlendMode: "multiply"
    },
    d: "M144.491 214.089h65.713v-37.94z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#EmptyActivityLog_svg__d)",
    fillRule: "nonzero",
    style: {
      mixBlendMode: "multiply"
    },
    d: "M47.152 294.165h18.054v8.139H47.152z"
  }), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m45.986 293.169-5.855-3.382a.71.71 0 0 1 0-1.345l5.855-3.38a2.577 2.577 0 0 1 2.33 0l5.856 3.38a.71.71 0 0 1 0 1.346l-5.855 3.38c-.733.372-1.598.372-2.33 0Z",
    fill: "#74DDDC",
    fillRule: "nonzero"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m54.172 289.788-5.855 3.38c-.733.372-1.598.372-2.33 0l-5.856-3.38a.819.819 0 0 1-.483-.673v8.856a.818.818 0 0 0 .483.673l5.855 3.38a2.571 2.571 0 0 0 2.33 0l5.856-3.38a.819.819 0 0 0 .483-.673v-8.856a.82.82 0 0 1-.483.673Z",
    fill: "url(#EmptyActivityLog_svg__e)",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#EmptyActivityLog_svg__f)",
    fillRule: "nonzero",
    style: {
      mixBlendMode: "multiply"
    },
    d: "M290.92 312.936H336v20.323h-45.08z"
  }), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M273.389 302.007c-.806-.464-1.207-1.072-1.207-1.68 0-.609.401-1.216 1.207-1.68l14.62-8.441a6.434 6.434 0 0 1 5.819 0l14.62 8.441c.804.464 1.206 1.071 1.206 1.681 0 .607-.402 1.215-1.205 1.679l-14.621 8.442a6.44 6.44 0 0 1-5.82 0l-14.62-8.442Z",
    fill: "#74DDDC",
    fillRule: "nonzero"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "m308.449 302.007-14.621 8.442a6.44 6.44 0 0 1-5.82 0l-14.62-8.442c-.805-.464-1.206-1.072-1.206-1.68v22.114c0 .61.401 1.217 1.207 1.68l14.62 8.441c1.828.93 3.99.93 5.819 0l14.62-8.44c.804-.464 1.206-1.071 1.206-1.68v-22.115c0 .608-.402 1.216-1.205 1.68Z",
    fill: "url(#EmptyActivityLog_svg__g)",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#EmptyActivityLog_svg__h)",
    fillRule: "nonzero",
    style: {
      mixBlendMode: "multiply"
    },
    d: "M162.16 360.05h25.508v11.499H162.16z"
  }), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "m160.513 358.642-8.272-4.777a1.003 1.003 0 0 1 0-1.9l8.272-4.777a3.64 3.64 0 0 1 3.293 0l8.273 4.776a1.004 1.004 0 0 1 0 1.901l-8.273 4.777a3.644 3.644 0 0 1-3.293 0Z",
    fill: "#F6F6FB",
    fillRule: "nonzero"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "m172.08 353.865-8.274 4.777a3.644 3.644 0 0 1-3.293 0l-8.272-4.777a1.157 1.157 0 0 1-.683-.95v12.513c.038.417.3.78.683.95l8.272 4.776a3.633 3.633 0 0 0 3.293 0l8.273-4.776c.383-.17.644-.534.682-.95v-12.513c-.039.416-.3.78-.682.95Z",
    fill: "url(#EmptyActivityLog_svg__i)",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#EmptyActivityLog_svg__j)",
    fillRule: "nonzero",
    style: {
      mixBlendMode: "multiply"
    },
    d: "M74.229 184.46h16.884v7.61H74.229z"
  }), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "m73.139 183.528-5.476-3.162a.664.664 0 0 1 0-1.258l5.476-3.162a2.41 2.41 0 0 1 2.179 0l5.476 3.162a.664.664 0 0 1 0 1.258l-5.476 3.162a2.412 2.412 0 0 1-2.18 0Z",
    fill: "#F6F6FB",
    fillRule: "nonzero"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "m80.794 180.366-5.476 3.162a2.412 2.412 0 0 1-2.18 0l-5.475-3.162a.766.766 0 0 1-.452-.63v8.283a.765.765 0 0 0 .452.63l5.476 3.16a2.405 2.405 0 0 0 2.179 0l5.476-3.16a.765.765 0 0 0 .451-.63v-8.282a.766.766 0 0 1-.451.629Z",
    fill: "url(#EmptyActivityLog_svg__k)",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#EmptyActivityLog_svg__l)",
    fillRule: "nonzero",
    style: {
      mixBlendMode: "multiply"
    },
    d: "M113.576 267.678h40.06v7.364h-40.06z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#EmptyActivityLog_svg__m)",
    fillRule: "nonzero",
    style: {
      mixBlendMode: "multiply"
    },
    d: "M95.646 257.055h40.056v7.36H95.646z"
  }), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M91.047 262.145c0-5.782 3.667-5.951 3.667-5.951s1.983 0 5.209-1.34c3.182-1.32 7.666-.81 5.16 3.814a1.145 1.145 0 0 1-.086.17c-.21.3-.488.545-.813.714l-8.01 4.7c-1.222.694-5.098-.915-5.127-2.107Z",
    fill: "url(#EmptyActivityLog_svg__n)",
    fillRule: "nonzero"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M91.07 261.629c.07 1.185 3.894 2.767 5.104 2.074l8.01-4.695c.4-.24.779-.515 1.129-.823-.072.157-.138.31-.23.483a1.145 1.145 0 0 1-.086.17c-.21.3-.488.545-.813.714l-8.01 4.7c-1.142.651-4.617-.722-5.075-1.878a1.223 1.223 0 0 1-.038-.233 3.446 3.446 0 0 1 .009-.513Z",
    fill: "#121047",
    fillRule: "nonzero"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M92.54 255.434c.943 0 4.266.846 4.266.846.025.307.127.603.298.86.032.035.063.073.092.112.656.456 1.322 1.175-.234 2.153-1.276.8-2.31.291-2.8-.2a2.546 2.546 0 0 0-.904-1.026 2.24 2.24 0 0 0-.866-.363c0-.026-.006-.082-.006-.082s-.242-2.3.153-2.3Z",
    fill: "#FFF",
    fillRule: "nonzero"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M92.477 198.878c3.624.066 12.674.23 16.295.292-1.347 10.886-4.06 20.773-5.87 31.317-1.945 10.246-4.135 17.446-6.047 25.972-.7 1.587-3.903.988-4.553-.54-.505-7.853-1.09-17.42 1.239-26.48-.389-9.765-1.29-20.697-1.064-30.561Z",
    fill: "url(#EmptyActivityLog_svg__o)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M109.306 272.773c0-5.783 3.666-5.952 3.666-5.952s1.984 0 5.21-1.337c3.18-1.322 7.663-.812 5.159 3.81-.025.059-.055.117-.088.173-.208.3-.487.545-.812.712l-8.007 4.697c-1.222.697-5.1-.912-5.127-2.103Z",
    fill: "url(#EmptyActivityLog_svg__p)",
    fillRule: "nonzero"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M109.325 272.253c.07 1.187 3.898 2.769 5.11 2.076l8.006-4.693c.4-.24.78-.517 1.13-.826-.076.159-.137.313-.23.483-.025.06-.055.118-.088.174-.208.3-.487.545-.812.712l-8.007 4.697c-1.144.655-4.62-.719-5.077-1.872a1.013 1.013 0 0 1-.035-.237 3.897 3.897 0 0 1 .004-.514Z",
    fill: "#121047",
    fillRule: "nonzero"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M110.798 266.06c.941 0 4.264.844 4.264.844.026.307.127.603.294.862.036.038.064.075.095.112.657.456 1.325 1.176-.233 2.153-1.272.8-2.306.292-2.8-.197a2.568 2.568 0 0 0-.902-1.027 2.326 2.326 0 0 0-.866-.365.716.716 0 0 0-.009-.078s-.241-2.305.157-2.305Z",
    fill: "#FFF",
    fillRule: "nonzero"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M103.97 224.763c-.99-4.679-12.41-5.259-11.66-23.66 3.582-.527 21.657 7.953 25.238 7.425.448 10.956-.61 21.158-.677 31.85-.243 10.426-1.23 17.888-1.724 26.613-.431 1.683-3.687 1.612-4.578.212-1.783-7.665-3.92-17.01-3.103-26.33-1.064-5.16-2.337-10.629-3.496-16.11Z",
    fill: "url(#EmptyActivityLog_svg__q)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M100.575 165.374c-12.753 8.52-14.273 25.442-7.38 36.177 0 0-1.481-23.792 7.38-36.177Z",
    fill: "url(#EmptyActivityLog_svg__r)",
    fillRule: "nonzero"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M122.207 207.859c-1.223-9.633-8.487-19.12-11.518-25.185-1.361.444-2.695.967-3.996 1.565 1.111 3.944 10.232 23.62 10.232 23.62h5.282Z",
    fill: "url(#EmptyActivityLog_svg__s)",
    fillRule: "nonzero",
    transform: "rotate(-90 114.45 195.266)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M99.99 211.533c7.76 4.359 15.883 4.365 18.65-.989-1.036-9.968-2.007-18.08-.007-27.637-.588-5.276-1.006-6.068-.33-9.149-.238-1.032-3.414-3.236-5.726-5.347-2.498-2.278-4.185-4.45-5.474-4.711-10.613-2.168-15.769 16.743-14.88 36.906.818 5.36 3.947 8.786 7.768 10.927Z",
    fill: "url(#EmptyActivityLog_svg__t)",
    fillRule: "nonzero"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M101.218 164.904c2.3-1.666 2.118-5.105 1.923-7.389a11.186 11.186 0 0 1-.429-3.945c.34-5.03 3.838-9.16 7.745-8.625 7.877 1.077 6.188 5.149 5.847 10.178-.314 4.661-2.645 7.726-6.215 8.026-.053.768.26 3.094 1.225 4.062-2.59 1.55-6.371.82-7.867.147-1.59-.722-3.31-1.337-2.229-2.454Z",
    fill: "#FCD1A9",
    fillRule: "nonzero"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M113.603 142.488c-.186-.63-1.39-1.042-5.48.534-.026.012-.994.39-1.056.413-7.574 3.28-5.744 12.013-4.613 14.333a4.72 4.72 0 0 1 .597 2.748c2.975-.123 3.918 1.552 5.824-.117 1.368-1.194 3.413-2.596 3.757-3.184.247-.439.345-.946.28-1.445.006-4.182 1.938-1.629 1.877-.665.793-.387.74-2.07.687-3.94 6.43-4.796 2.977-8.106-1.872-8.677Z",
    fill: "url(#EmptyActivityLog_svg__u)",
    fillRule: "nonzero"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M127.66 188.094c-2.712-5.338-4.643-7.552-9.451-14.57-1.115-1.65-4.717-1.024-6.491 1.318-2.402 3.165-1.376 7.773-.018 9.646 3.487 3.606 5.96 5.09 9.035 7.592 5.044 4.105 9.044.18 6.925-3.986Z",
    fill: "url(#EmptyActivityLog_svg__v)",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M87.362 120.483c.025-4.332 3.183-8.081 6.746-10.138 3.562-2.057 6.847-2.174 6.77 2.247 0 4.23-3.36 6.607-4.825 8.591-.682.92-.96 1.897-.96 3.268v.145l-3.335 1.926v-.175c.025-4.011 1.44-5.733 2.78-7.323 1.338-1.59 2.88-2.713 2.88-4.463 0-2.247-1.794-1.736-3.36-.832-1.618.934-3.285 2.947-3.31 4.8l-3.386 1.954Zm8.06 7.454c0 3.063-4.043 5.397-4.043 2.334 0-3.093 4.043-5.426 4.043-2.334Z",
    fill: "#FB944B",
    fillRule: "nonzero",
    style: {
      mixBlendMode: "screen"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.247 224.568c-4-2.312-9.322-3.374-14.547-3.22H18.196v1.342a21.635 21.635 0 0 0-4.337 1.878c-7.448 4.333-7.406 11.352.09 15.686a21.696 21.696 0 0 0 4.247 1.836v1.402h12.138c4.724-.076 9.405-1.15 13.003-3.234 7.448-4.338 7.414-11.357-.09-15.69Z",
    fill: "url(#EmptyActivityLog_svg__w)",
    fillRule: "nonzero",
    style: {
      mixBlendMode: "multiply"
    }
  }), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M5.652 240.243c-3.775-2.18-5.658-5.038-5.652-7.896l.016-6.905c-.007 2.857 1.876 5.716 5.651 7.897 7.502 4.33 19.62 4.33 27.072.005 3.703-2.156 5.556-4.969 5.563-7.787l-.015 6.9c-.01 2.82-1.86 5.637-5.564 7.79-7.448 4.328-19.569 4.328-27.072-.004Z",
    fill: "url(#EmptyActivityLog_svg__x)",
    fillRule: "nonzero"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M5.668 233.34c-7.5-4.33-7.54-11.349-.09-15.68 7.453-4.331 19.576-4.331 27.073 0 7.502 4.331 7.539 11.35.088 15.684-7.451 4.324-19.57 4.324-27.072-.005Z",
    fill: "#F6F6FB",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M190.48 223.52c-2.39-1.38-5.566-2.014-8.686-1.922h-6.272v.801c-.902.278-1.77.654-2.59 1.122-4.447 2.587-4.421 6.777.055 9.365.803.455 1.653.823 2.535 1.097v.836h7.247c2.821-.045 5.616-.686 7.765-1.93 4.447-2.59 4.426-6.781-.055-9.368Z",
    fill: "url(#EmptyActivityLog_svg__y)",
    fillRule: "nonzero",
    style: {
      mixBlendMode: "multiply"
    }
  }), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M168.032 232.88c-2.254-1.302-3.378-3.008-3.374-4.715l.01-4.123c-.005 1.707 1.12 3.413 3.373 4.716 4.48 2.585 11.715 2.585 16.165.003 2.21-1.288 3.316-2.967 3.32-4.65l-.008 4.12c-.006 1.684-1.11 3.366-3.322 4.651-4.447 2.585-11.685 2.585-16.164-.002Z",
    fill: "url(#EmptyActivityLog_svg__z)",
    fillRule: "nonzero"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M168.041 228.758c-4.478-2.586-4.502-6.776-.054-9.362 4.451-2.586 11.69-2.586 16.166 0 4.48 2.586 4.501 6.776.053 9.365-4.45 2.582-11.686 2.582-16.165-.003Z",
    fill: "#F6F6FB",
    fillRule: "nonzero"
  }))));
};
export default SvgEmptyActivityLog;